<template>
  <div class="container">
    <label class="label" v-if="label">{{ label }}</label>

    <div :id="dropDownId" class="select-container">
      <div @click="showOptions = !showOptions" class="selected">
        <p class="selected-text" :class="colorClasses">{{ selectedText }}</p>
        <i class="fa fa-caret-down icon"></i>
      </div>

      <div class="options-container" v-if="showOptions">
        <div :class="selectedClass(option)"
             :key="option.id"
             @click="optionClicked(option)"
             class="option"
             v-for="option in optionsCache">
          <p class="option-text">{{ getText(option) }}</p>
          <i class="fa fa-check option-icon" v-if="isSelected(option)"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectDropDown",
  props: {
    id: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    defaultSelected: Object,
    placeholder: String,
    name: String,
    label: String,
    selector: String,
    newSelected: Object
  },
  created() {
    if (this.defaultSelected) {
      this.selectedOption = this.optionsCache.find((opt) => opt.id === this.defaultSelected.id);
    }
  },
  mounted() {
    // hide dropdown on outside click
    window.addEventListener('click', (e) => {
      if (document.getElementById('dropDown_' + this.id) && !document.getElementById('dropDown_' + this.id).contains(e.target)) {
        this.showOptions = false;
      }
    })
  },
  data() {
    return {
      showOptions: false,
      selectedOption: null,
      optionsCache: this.options
    };
  },
  methods: {
    isSelected(option) {
      return this.selectedOption && this.selectedOption.id === option.id;
    },
    selectedClass(option) {
      return this.isSelected(option) ? 'option-selected' : '';
    },
    optionClicked(option) {
      this.showOptions = false;
      this.selectedOption = option;
    },
    getText(option) {
      if (this.selector) {
        return option[this.selector];
      }
      return option.name;
    }
  },
  computed: {
    selectedText() {
      if (this.selectedOption) {
        return this.getText(this.selectedOption);
      }

      if (this.placeholder) {
        return this.placeholder;
      }

      return '';
    },
    colorClasses() {
      return this.selectedOption ? '' : 'placeholder';
    },
    dropDownId() {
      return 'dropDown_' + this.id;
    }
  },
  watch: {
    // emit action when new selected option
    selectedOption(newVal, oldVal) {
      this.$emit('selection-change', {
        dropDownId: this.id,
        name: this.name,
        label: this.label,
        currentValue: newVal,
        oldValue: oldVal
      });
    },
    options: {
      handler(newVal) {
        this.optionsCache = newVal;
        if (this.defaultSelected) {
          this.selectedOption = this.optionsCache.find((opt) => opt.id === this.defaultSelected.id);
        } else {
          this.selectedOption = null;
        }
      },
      deep: true
    },
    newSelected: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.selectedOption = this.optionsCache.find((opt) => opt.id === newVal.id);
        } else {
          this.selectedOption = null;
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
@import "../../../css/shared/input.css";

.placeholder {
  color: var(--grey);
  opacity: 0.5;
  font-size: 21px;
}

.icon {
  float: right;
  color: var(--dark-grey) !important;
  margin-left: 0 !important;
  margin-top: 0 !important;
  font-size: 20px !important;
}

.select-container {
  font-family: Arial, Helvetica, sans-serif;
  color: var(--dark-grey);
  background-color: var(--very-light-grey);
  display: inline-block;
  float: left;
  height: 50px;
  width: 100%;
  border: 0;
  border-bottom: 2px solid;
  resize: horizontal;
  font-weight: normal !important;
}

.selected {
  display: inline-block;
  width: 100%;
  height: inherit;
  font-size: 21px;
  padding: 11px 12px;
  text-align: left;
  box-sizing: border-box;
}

.selected:hover {
  background: var(--lighter-grey);
  cursor: pointer;
  border-radius: 8px 8px 0 0;
}

.options-container {
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  border: solid #cbcbcb;
  border-width: 0 1px 1px 1px;
  background-color: #ffffff;
  display: inline-block;
  margin: 0;
  z-index: 100;
  position: relative;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 5px -2px var(--shadow-color);
  -moz-box-shadow: 0 0 5px -2px var(--shadow-color);
  box-shadow: 0 0 5px -2px var(--shadow-color);
}

.option {
  float: left;
  width: 100%;
  padding: 10px;
  text-align: left;
  background-color: #ffffff;
  color: var(--dark-grey);
  box-sizing: border-box;
  position: relative;
}

.option-text {
  font-size: 18px;
  width: fit-content;
  display: inline-block;
}

.option-icon {
  font-size: 12px;
  float: right;
}

.option:hover {
  background: var(--very-light-grey);
  cursor: pointer;
}

.option-selected {
  color: var(--blue);
  background-color: var(--very-light-blue);
}

.selected-text {
  width: 85%;
  margin-top: 2px;
  margin-bottom: 2px;
  float: left;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: fit-content;
}

.filter-input .select-container {
  height: 28px !important;
}

.filter-input .icon {
  margin-top: 5px;
}

.filter-input .selected {
  padding: 0 11px;
}
</style>
